import config from '@plone/volto/registry';
// TODO: Replace with native
import { cloneDeep } from 'lodash';
import { connect } from 'react-redux';

function getSourceData(data, state) {
  const sourceSettings = Object.entries(data).reduce(
    (validData, [key, val]) => {
      if (key !== 'source' && key.startsWith('source')) {
        validData[key.replace('source_', '')] = val;
      }
      return validData;
    },
    {},
  );
  const source = config.settings['volto-repeater-block'].sources[data.source];
  return source.fetchFromSource(sourceSettings, state);
}

function DefaultRepeaterWrapper({ children }) {
  return <>{children}</>;
}

function RepeaterBlockViewComponent({ data, ...props }) {
  const Block = config.blocks.blocksConfig[data.blockType]?.view;
  const RepeaterWrapper =
    config.blocks.blocksConfig[data.blockType]?.RepeaterWrapper ||
    DefaultRepeaterWrapper;

  if (!Block) {
    return null;
  }

  const blockData = Object.entries(data).reduce((validData, [key, val]) => {
    if (key.startsWith('block_')) {
      validData[key.replace('block_', '')] = val;
    }
    return validData;
  }, {});

  // TODO: Memoise so it doesn't re-run every render
  const sourceData = getSourceData(data, props.state);

  return (
    <RepeaterWrapper>
      {sourceData.map((dataFromSource, index) => {
        const localBlockData = cloneDeep(blockData);
        // Overwrite the block data if it's being mapped
        const mapping =
          config.settings['volto-repeater-block']?.mappings?.[data.blockType]?.[
            data.source
          ] || {};
        Object.entries(mapping).forEach(([blockField, sourceField]) => {
          if (sourceField in dataFromSource) {
            localBlockData[blockField] = dataFromSource[sourceField];
          }
        });

        return <Block key={index} id={'fake_block_id'} data={localBlockData} />;
      })}
    </RepeaterWrapper>
  );
}

// Needed to pass the redux state through to the `fetchFromSource` function of a source
//    so that it can use the current state of the page/ site to populate the repeater.
export default connect((state) => {
  return {
    state: state,
  };
})(RepeaterBlockViewComponent);
